import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useHomeGetSectionByIdQuery, useHomeUpdateSectionsMutation } from "../../../../Services/HomeAPI";
import { useNavigate, useParams } from "react-router-dom";

function AddCategory() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isLoading: isLoadingContent, error, refetch } = useHomeGetSectionByIdQuery(id);

  console.log("data", data)
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [isTitleActive, setIsTitleActive] = useState(1);
  const [smallHeading, setSmallHeading] = useState("");
  const [isSmallHeadingActive, setIsSmallHeadingActive] = useState(1);
  const [description, setDescription] = useState("");
  const [isDescriptionActive, setIsDescriptionActive] = useState(1);
  const [productSource, setProductSource] = useState("");

  const [isActive, setIsActive] = useState(1);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  useEffect(() => {
    refetch();
  }, [refetch])

  const [UpdateLIst, { isLoading }] = useHomeUpdateSectionsMutation();

  useEffect(() => {
    setName(data?.data?.name);
    setTitle(data?.data?.title);
    setIsTitleActive(data?.data?.is_title_active ? 1 : 0);
    setSmallHeading(data?.data?.small_heading);
    setIsSmallHeadingActive(data?.data?.is_title_active ? 1 : 0);
    setDescription(data?.data?.description);
    setIsDescriptionActive(data?.data?.isDescriptionActive);
    setProductSource(data?.data?.product_source);
    setIsActive(data?.data?.is_active)
  }, [data])

  const validateForm = () => {
    let newErrors = {};
    if (!title.trim()) newErrors.title = "Title is required";
    if (!name.trim()) newErrors.name = "Name is required";
    if (!smallHeading.trim()) newErrors.smallHeading = "Small heading is required";
    if (!description.trim()) newErrors.description = "Description is required";
    if (!productSource.trim()) newErrors.productSource = "Please select product source";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("name", name);
    formData.append("title", title);
    formData.append("is_title_active", isTitleActive ? 1 : 0);
    formData.append("small_heading", smallHeading);
    formData.append("is_small_heading_active", isSmallHeadingActive ? 1 : 0);
    formData.append("description", description);
    formData.append("is_description_active", isDescriptionActive ? 1 : 0);
    formData.append("product_source", productSource);

    formData.append("is_active", isActive ? 1 : 0);

    try {
      await UpdateLIst({ formData, id }).unwrap();
      alert("Section Updated successfully!");
      setTitle("");
      setTitle("");
      setIsTitleActive(1);
      setSmallHeading("");
      setIsSmallHeadingActive(1);
      setDescription("");
      setIsDescriptionActive(1);
      setProductSource("");

      setIsActive(1);
      setErrors({});
      setApiError(null);
      navigate("/home-section-list");
    } catch (error) {
      setApiError(error.data?.message || "Something went wrong");
    }
  };


  if (isLoadingContent) return <div class="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  return (
    <div>
      <h3>Add Sections</h3>
      <div className="breadcrum mb-4">
        <p>
          <Link to="/home-section-list"><span>Secion</span></Link>
          <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
          <span className="active-link">Edit</span>
        </p>
      </div>
      <div className="content-wrapper">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            {/* Title */}

            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                {errors.name && <p className="text-danger">{errors.name}</p>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Title</label>
                <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
                {errors.title && <p className="text-danger">{errors.title}</p>}
              </div>
            </div>

            {/* Title Active */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Is Title Active</label>
                <select className="form-control" value={isTitleActive} onChange={(e) => setIsTitleActive(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>

            {/* Small Heading */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Small Heading</label>
                <input type="text" className="form-control" value={smallHeading} onChange={(e) => setSmallHeading(e.target.value)} />
                {errors.smallHeading && <p className="text-danger">{errors.smallHeading}</p>}
              </div>
            </div>

            {/* Small Heading Active */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Is Small Heading Active</label>
                <select className="form-control" value={isSmallHeadingActive} onChange={(e) => setIsSmallHeadingActive(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>

            {/* Description */}
            <div className="col-md-12">
              <div className="mb-4 text-start">
                <label className="form-label">Description</label>
                <textarea className="form-control" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
                {errors.description && <p className="text-danger">{errors.description}</p>}
              </div>
            </div>

            {/* Description Active */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Is Description Active</label>
                <select className="form-control" value={isDescriptionActive} onChange={(e) => setIsDescriptionActive(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>

            {/* Product Source */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Product Source</label>
                <select className="form-control" value={productSource} onChange={(e) => setProductSource(e.target.value)}>
                  <option value="">Select Product source</option>
                  <option value="featured">Featured</option>
                  <option value="best_seller">Best Seller</option>
                  <option value="top_rated">Top Rated</option>
                  <option value="new_arrivals">New Arrivals</option>
                  <option value="category">Category</option>
                  <option value="featured_category">Featured Category</option>
                </select>
                {errors.productSource && <p className="text-danger">{errors.productSource}</p>}
              </div>
            </div>


            {/* Is Active */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Is Active</label>
                <select className="form-control" value={isActive} onChange={(e) => setIsActive(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>
          </div>
          {apiError && <p className="text-danger text-center">{apiError}</p>}
          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddCategory;
